import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'BreadCrumbs',
  templateUrl: './BreadCrumbs.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/jquery.dropdownReplacement.css',
    '../../Content/css/jquery.dropdownReplacementhotel.css']
})
export class BreadCrumbs implements OnInit {
  BreadCrumblist: BreadCrumb[] = [];

  constructor(private router: Router, private activatedroute: ActivatedRoute) { }

  ngOnInit() {
    this.BreadCrumbs();
  }

  BreadCrumbs() {
    let PagePath: string = this.activatedroute.snapshot.url[0].path;
    switch (PagePath) {
      case "Users":
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Administration     ", "/Users", null));
        this.BreadCrumblist.push(new BreadCrumb(" ", " ", " ", null));
        this.BreadCrumblist.push(new BreadCrumb(" >  ", "Users ", "/  Users ", null));
        break;

      case "Reports":
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Reports", "/Reports", null));
        break;

          
      case "Service Monitoring Detailed":
       // var ParentPage = JSON.parse(atob(this.activatedroute.snapshot.params['ReportName']));
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Administration".trim(), "/Service Monitoring Detailed", null));
        this.BreadCrumblist.push(new BreadCrumb("> ", "Service Monitoring Detailed", "/Service Monitoring Detailed ", null));
        this.BreadCrumblist.push(new BreadCrumb("  ", " ", "", null));
        break;

      case "Backup Database":
        // var ParentPage = JSON.parse(atob(this.activatedroute.snapshot.params['ReportName']));
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Administration".trim(), "/Backup Database", null));
        this.BreadCrumblist.push(new BreadCrumb("> ", "Backup Database", "/Backup Database", null));
        this.BreadCrumblist.push(new BreadCrumb("` ", " ", "", null));
        break;

      case "Punch Faces":
        
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Administration     ", "/Punch Faces", null));
        this.BreadCrumblist.push(new BreadCrumb(" ", " ", "", null));
        this.BreadCrumblist.push(new BreadCrumb(" >  ", "Punch Faces ", "/  Punch Faces ", null));
       
        break;

      case "PDF to Excel Converter":
        
      //  this.BreadCrumblist.push(new BreadCrumb(" > ", " ", "/PDF to Excel Converter", null));
       // this.BreadCrumblist.push(new BreadCrumb(" ", " ", "", null));
       // this.BreadCrumblist.push(new BreadCrumb(" >  ", "PDF to Excel Converter", "/  PDF to Excel Converter ", null));
        this.BreadCrumblist.push(new BreadCrumb(" > ", "PDF to Excel Converter", "/PDF to Excel Converter", null));
        break;

      case "AutoImportSearch":

        this.BreadCrumblist.push(new BreadCrumb(" > ", "Administration", "/Service Monitoring Detailed", null));
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Service Monitoring Detailed", "/Service Monitoring Detailed", null));
        this.BreadCrumblist.push(new BreadCrumb("`  ", "`  ", "", null));
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Service Monitoring ", "/Service Monitoring", null));
        //this.BreadCrumblist.push(new BreadCrumb(" > ", "Administration", "/Service Monitoring (Detailed)", null));
        //this.BreadCrumblist.push(new BreadCrumb(" > ", "Service Monitoring (Detailed)", "/Service Monitoring (Detailed)", null));
        //this.BreadCrumblist.push(new BreadCrumb("` ", " ", " ", null));
        //this.BreadCrumblist.push(new BreadCrumb(" > ", "Service Monitoring", "/Service Monitoring", null));
        break;

      case "PLGroupingReports":
        var ParentPage = JSON.parse(atob(this.activatedroute.snapshot.params['ReportName']));
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Reports".trim(), "/Reports", null));
        this.BreadCrumblist.push(new BreadCrumb(" > ",ParentPage.trim(), "/PLGroupingReports", null));
        break;

      case "Organization":

        this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null));
        break;

      case "OrganizationDetails":
        
        if (this.activatedroute.snapshot.params['pageName'] != undefined) {
          var ParentPage = JSON.parse(atob(this.activatedroute.snapshot.params['pageName']));
          if (ParentPage == "EntitySearch") {
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Entity", "/Entity", null))
            this.BreadCrumblist.push(new BreadCrumb(" ", " ", "", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
            break;
          }
          else if (ParentPage == "CreateEntity") {
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null))
            this.BreadCrumblist.push(new BreadCrumb(" ", " ", "", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
            break;
          }
          else if (ParentPage == "Subscription") {
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Subscription", "/Subscription", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details", "/OrganizationDetails", null));
            break;
          }
          else if (ParentPage == "SubscriptionDetails") {
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Subscription", "/Subscription", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Subscription Details", "/SubscriptionDetails", null));
            this.BreadCrumblist.push(new BreadCrumb(" ", " ", "", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
            break;
          }
          else if (ParentPage == "SubscriptionDetail") {
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null))
            this.BreadCrumblist.push(new BreadCrumb(" ", " ", "", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
            break;
          }
          else if (ParentPage == "Payroll-Revision") {
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null))
            this.BreadCrumblist.push(new BreadCrumb(" ", " ", "", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
            break;
          }
          else if (ParentPage == "Feature Configurations") {
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null))
            this.BreadCrumblist.push(new BreadCrumb(" ", " ", "", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
            break;
          }

          else {
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null))
            this.BreadCrumblist.push(new BreadCrumb(" ", " ", "", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
            break;
          }
        }
        else {
          this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null))
          this.BreadCrumblist.push(new BreadCrumb(" ", " ", "", null));
          this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
          break;
        }
      case "Entity":
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Entity", "/Entity", null));
        break;
      case "IF Users":
        this.BreadCrumblist.push(new BreadCrumb(" > ", "IF Users", "/IF Users", null));
        break;
      case "Feature Configurations":
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null));
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Features Configuration", "/Feature Configurations", null));
        break;
      case "CreateEntity":
        
        if (this.activatedroute.snapshot.params['pageName'] != undefined) {
          var ParentPage = JSON.parse(atob(this.activatedroute.snapshot.params['pageName']));

          if (ParentPage == "EntitySearch") {
            // this.BreadCrumblist.push(new BreadCrumb(" > ", "Entity", "/Entity", { TenantID: btoa(JSON.stringify('1')), pageName: btoa(JSON.stringify('EntitySearch')) }));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Entity", "/Entity", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Entity Details", "/CreateEntity", null));
          }
          else if (ParentPage == "Subscription") {
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Subscription", "/Subscription", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Entity Details", "/CreateEntity", null));
          }
          else if (ParentPage == "SubscriptionDetails") {
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Subscription", "/Subscription", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Subscription Details", "/SubscriptionDetails", null));
            this.BreadCrumblist.push(new BreadCrumb("`   ", " ", " ", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Entity Details", "/CreateEntity", null));
          }
          else if (ParentPage == "SubscriptionDetail") {
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
            this.BreadCrumblist.push(new BreadCrumb("`   ", " ", " ", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Entity Details", "/CreateEntity", null));
          }
          else {
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
            this.BreadCrumblist.push(new BreadCrumb(' ',' ' ,null, null));
            this.BreadCrumblist.push(new BreadCrumb(" > ", "Entity Details", "/CreateEntity", null));
          }
        }
        else {
          this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null));
          this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
          this.BreadCrumblist.push(new BreadCrumb("`   ", " ", " ", null));
          this.BreadCrumblist.push(new BreadCrumb(" > ", "Entity Details", "/CreateEntity", null));
        }
        break;

      case "Subscription":
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Subscriptions", "/Subscription", null));
        break;

      //case "SubscriptionDetails":
      //  this.BreadCrumblist.push(new BreadCrumb(" > ", "Subscription", "/Subscription", null));
      //  this.BreadCrumblist.push(new BreadCrumb(" ", " ", "", null));
      //  this.BreadCrumblist.push(new BreadCrumb(" > ", "Subscription Details", "/SubscriptionDetails", null));
      //  break;

      case "SubscriptionDetails":
        
        var ParentPage = JSON.parse(atob(this.activatedroute.snapshot.params['pageName']));
        if (ParentPage == "CreateEntity") {
          this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null));
          this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details ", "/OrganizationDetails", null));
          this.BreadCrumblist.push(new BreadCrumb(" ", " ", " ", null));
          this.BreadCrumblist.push(new BreadCrumb(" > ", "Entity Details", "/CreateEntity", null));
          this.BreadCrumblist.push(new BreadCrumb(" > ", "Subscription Details", "/SubscriptionDetails", null));
        }
        else if (ParentPage == "Subscription") {
          this.BreadCrumblist.push(new BreadCrumb(" > ", "Subscription", "/Subscription", null));
          this.BreadCrumblist.push(new BreadCrumb(" ", " ", "", null));
          this.BreadCrumblist.push(new BreadCrumb(" > ", "Subscription Details", "/SubscriptionDetails", null));
        }
        break;
      case "Payroll-Revision":
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization", "/Organization", null));
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Organization Details", "/OrganizationDetails", null));
        this.BreadCrumblist.push(new BreadCrumb("`   ", " ", " ", null));
        this.BreadCrumblist.push(new BreadCrumb(" > ", "Payroll Revision", "/Payroll-Revision", null));
        break;
    }

  }

  BreadcrumbUrl(Url: any, Parm: any) {
    console.log(Url);
    // let test = "/Entity",{TenantID:btoa(JSON.stringify('1')),pageName:btoa(JSON.stringify('EntitySearch'))};
    let test = { TenantID: btoa(JSON.stringify('1')), pageName: btoa(JSON.stringify('EntitySearch')) };
    if (Url == "" && Url == null) {
      return false;
    }
    else {
      if (Parm == null) {
        this.router.navigate([Url]);
      }
      else {
        this.router.navigate([Url, Parm]);
      }
    }
  }
}

export class BreadCrumb {
  constructor(
    public menuSeparator: string,
    public Resource: string,
    public Url: string,
    public Parm: any,
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/Shared/BreadCrumbs.ts